import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'channels.index',
      component: () => import(/* webpackChunkName: "channels" */ './views/ChannelList.vue'),
      meta: {
        auth: undefined,
        title: 'Channels'
      }
    },
    {
      path: '/channel/:category/:channel',
      name: 'channels.show',
      component: () => import(/* webpackChunkName: "channel" */ './views/Channel.vue'),
      meta: {
        auth: undefined
      }
    },
    {
      path: '/thread/:category/:channel',
      name: 'threads.create',
      component: () => import(/* webpackChunkName: "threadCreate" */ './views/ThreadCreate.vue'),
      meta: {
        auth: true
      }
    },
    {
      path: '/thread/:category/:channel/:thread',
      name: 'threads.show',
      component: () => import(/* webpackChunkName: "thread" */ './views/Thread.vue'),
      meta: {
        auth: undefined
      }
    },
    {
      path: '/users',
      name: 'users.index',
      component: () => import(/* webpackChunkName: "userList" */ './views/UserList.vue'),
      meta: {
        auth: undefined,
        title: 'Users'
      }
    },
    {
      path: '/profile',
      name: 'profile',
      component: () => import(/* webpackChunkName: "about" */ './views/Profile.vue'),
      meta: {
        auth: true,
        title: 'Your Profile'
      }
    },
    {
      path: '/email/verify/:username',
      name: 'email.verify',
      component: () => import(/* webpackChunkName: "forgotPassword" */ './views/EmailVerify.vue'),
      meta: {
        auth: true,
        title: 'Verify Your Email'
      }
    },
    {
      path: '/password',
      name: 'password.email',
      component: () => import(/* webpackChunkName: "forgotPassword" */ './views/ForgotPassword.vue'),
      meta: {
        auth: false,
        title: 'Forgot Password'
      }
    },
    {
      path: '/password/reset/:token',
      name: 'password.reset',
      component: () => import(/* webpackChunkName: "resetPassword" */ './views/ResetPassword.vue'),
      meta: {
        auth: false,
        title: 'Reset Password'
      }
    },
    {
      path: '/admin',
      name: 'admin',
      component: () => import(/* webpackChunkName: "admin" */ './views/Admin.vue'),
      meta: {
        auth: {
          roles: ['admin', 'super-moderator'],
          title: 'Admin'
        }
      }
    },
    {
      path: '/admin/users',
      name: 'admin.users',
      component: () => import(/* webpackChunkName: "admin.users" */ './views/admin/Users.vue'),
      meta: {
        auth: {
          roles: ['admin', 'super-moderator'],
          title: 'Users Admin'
        }
      }
    },
    {
      path: '/admin/channels',
      name: 'admin.channels',
      component: () => import(/* webpackChunkName: "admin.channels" */ './views/admin/Channels.vue'),
      meta: {
        auth: {
          roles: 'admin',
          title: 'Channels Admin'
        }
      }
    },
    {
      path: '/admin/emotes',
      name: 'admin.emotes',
      component: () => import(/* webpackChunkName: "admin.emotes" */ './views/admin/Emotes.vue'),
      meta: {
        auth: {
          roles: ['admin', 'super-moderator'],
          title: 'Emotes Admin'
        }
      }
    },
    {
      path: '/terms-of-use',
      name: 'terms',
      component: () => import(/* webpackChunkName: "terms" */ './views/Terms.vue'),
      meta: {
        auth: undefined,
        title: 'Terms of Use'
      }
    },
    {
      path: '/privacy-policy',
      name: 'privacy',
      component: () => import(/* webpackChunkName: "privacy" */ './views/Privacy.vue'),
      meta: {
        auth: undefined,
        title: 'Privacy Policy'
      }
    },
    {
      path: '/403',
      name: 'error.forbidden',
      component: () => import(/* webpackChunkName: "forbidden" */ './views/errors/Forbidden.vue'),
      meta: {
        auth: undefined,
        title: 'Forbidden'
      }
    },
    {
      path: '/404',
      name: 'error.notfound',
      component: () => import(/* webpackChunkName: "notfound" */ './views/errors/NotFound.vue'),
      meta: {
        auth: undefined,
        title: 'Page Not Found'
      }
    },
    {
      path: '*',
      component: () => import(/* webpackChunkName: "notfound" */ './views/errors/NotFound.vue'),
      meta: {
        auth: undefined,
        title: 'Page Not Found'
      }
    }
  ]
})

router.beforeResolve((to, from, next) => {
  // if (to.name !== from.name) {
  //   Vue.toasted.clear()
  // }
  next()
})

router.beforeEach((to, from, next) => {
  const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);

  if(nearestWithTitle) {
    document.title = nearestWithTitle.meta.title + ' - Nexus - The Pylon Show'
  }else{
    document.title = 'Nexus - The Plyon Show'
  }

  next();
});

export default router
